var map = {
	"./01_local.ts": 1030,
	"./02_w-devl-05.ts": 1031,
	"./03_w-devl-06.ts": 1032,
	"./04_w-devl-07.ts": 1033,
	"./05_w-devl-08.ts": 1034,
	"./06_pg_1243.ts": 1035,
	"./07_pg_1278.ts": 1036,
	"./53v2_RUN-S2-53-v2.ts": 1037,
	"./55v2_RUN-S2-55-v2.ts": 1038,
	"./56v2_RUN-S2-56-v2.ts": 1039,
	"./AppConfig.ts": 1040,
	"./DEV.ts": 1041,
	"./Uphoc-Dev.ts": 1042,
	"./Uphoc-Master-Pharmamove.ts": 1043,
	"./Uphoc-Master.ts": 1044,
	"./Uphoc-PROD-IP.ts": 1045,
	"./Uphoc-PROD.ts": 1046,
	"./Uphoc-Pharmagarde.ts": 1047,
	"./Uphoc-RESTORE-PROD.ts": 1048,
	"./Uphoc-Test.ts": 1049,
	"./index.ts": 104,
	"./pg-1142.ts": 1050,
	"./pg-1196.ts": 1051,
	"./pg-1398.ts": 1052,
	"./pg-985.ts": 1053
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1029;